import { useSelector } from 'react-redux'

import type { CollectionUUID } from '@library/menu-service'

import { CollectionId } from 'routes/Menu/domains/collections'
import { getUserFirstName } from 'selectors/user'

import { useCollection } from './useCollection'

export const useCollectionShortTitle = (id: CollectionUUID | null): string => {
  const collection = useCollection(id)
  const userFirstName = useSelector(getUserFirstName)

  if (id === CollectionId.Recommendations && userFirstName) {
    return `For ${userFirstName}`
  }

  return collection?.shortTitle ?? 'Recommendations'
}
